import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';

const AUTOMATIC = new Set(['memberName', 'gymName', 'expiryDate', 'daysLeft']);
export function templateFields(template) {
  return [...new Set([...`${template?.title || ''} ${template?.body || ''}`.matchAll(/\{\{\s*(\w+)\s*\}\}/g)].map(match => match[1]))]
    .filter(key => !AUTOMATIC.has(key));
}
export function missingTemplateFields(template, values = {}) {
  return templateFields(template).filter(key => !String(values[key] ?? '').trim());
}
export function previewTemplate(text, values = {}) {
  return (text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => String(values[key] ?? '').trim() ? values[key] : match);
}
export default function TemplateFields({ template, values, onChange, disabled = false }) {
  const fields = templateFields(template);
  if (!fields.length) return null;
  return <Stack spacing={1.5} sx={{ my: 2 }}>
    <Typography variant="subtitle2">Required template fields</Typography>
    <Typography variant="caption" color="text.secondary">These values apply to every recipient in this send. Member and gym details are filled automatically.</Typography>
    {fields.map(key => <TextField key={key} required fullWidth size="small" disabled={disabled}
      label={key.replace(/([A-Z])/g, ' $1').replace(/^./, char => char.toUpperCase())}
      value={values[key] ?? ''} onChange={event => onChange({ ...values, [key]: event.target.value })} />)}
  </Stack>;
}
